import React from "react";
import { connect } from "react-redux";
import SshPaswordlessKeyField from "./SshPasswordlessKeyFeild";
import SshUsernameField from "./SshUsernameField";
import SshPasswordField from "./SshPasswordField";
import EnablePasswordField from "./EnablePasswordField";
import CentralCredentialsField from "./CentralCredentialsField";

function SshConnectionFieldset({ disabled, sshPasswordlessKey }) {

    //const [selectedCentralCredential, setSelectedCentralCredential] = useState(null);
    return (
        <fieldset className="oct_fieldset oct_fieldset-inner oct_fieldset-ssh">
            <CentralCredentialsField disabled={disabled} />
            <div className="row modal-v2-auth-grid">
                <div className="col-md-6 modal-v2-auth-col">
                    <SshUsernameField disabled={disabled || !!sshPasswordlessKey} passwordlessKeyActive={!!sshPasswordlessKey} />
                </div>
                <div className="col-md-6 modal-v2-auth-col">
                    <SshPasswordField disabled={disabled || !!sshPasswordlessKey} />
                </div>
            </div>
            <EnablePasswordField />
            {/* <EnablePasswordTextField/> */}
            <p className="modal-v2-or-divider">OR</p>
            <SshPaswordlessKeyField disabled={disabled} />
        </fieldset>
    )

}

export default connect(state => ({
    sshPasswordlessKey: state.addDeviceModal.sshPasswordlessKey
}))(SshConnectionFieldset);